import axios from '../../axios';

const getWorkingHours = async (stylist_id) => {
  try {
    const { data } = await axios.get(`/settings/working_hours/${stylist_id}`);
    console.log(data, "working hours!!!!!!!!!!!");
    return data;
  } catch (e) {
    return null;
  }
};

const updateWorkingHours = async ({ userInfo, stylist_id}) => {
  try {
    const { data } = await axios.put(`/settings/working_hours/${stylist_id}`, userInfo);
    return data;
  } catch (e) {
    return null;
  }
};

export { getWorkingHours, updateWorkingHours };

